import { ISelectOption } from 'components/forms/Selects/SelectOption'
import { IDayRange, TMarketInsightRangeKeys } from './types'

export const DAY_RANGE_OPTIONS: ISelectOption<IDayRange>[] = [
  {
    label: '7 Days',
    value: IDayRange.LastSevenDays,
  },
  {
    label: '14 Days',
    value: IDayRange.LastFourteenDays,
  },
  {
    label: '30 Days',
    value: IDayRange.LastThirtyDays,
  },
]

export const MARKET_INSIGHT_RANGE_KEYS: Record<IDayRange, TMarketInsightRangeKeys> = {
  [IDayRange.LastSevenDays]: 'changeLastSevenDays',
  [IDayRange.LastFourteenDays]: 'changeLastFourteenDays',
  [IDayRange.LastThirtyDays]: 'changeLastThirtyDays',
}

export const TEST_IDS = {
  dayRangeSelect: 'day-range-select',
  pickupMarketInsight: 'pickup-market-insight',
  deliveryMarketInsight: 'delivery-market-insight',
  locationText: 'location-text',
  percentageChangeText: 'percentage-change-text',
}
